import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';

import * as colors from '../../styles/colors';

const Error = props => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <span className={classes.title}>{props.title}</span>
        <span className={classes.message}>{props.message}</span>
        {props.onButtonPress && (
          <span className={classes.buttonContainer}>
          <Button variant='contained' color='primary' onClick={props.onButtonClick}>
            {props.buttonText}
          </Button>
        </span>
        )}
      </div>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    maxWidth: 200,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  title: {
    marginEnd: 16,
    marginStart: 16,
    fontSize: 20,
    textAlign: 'center',
    color: colors.BLACK
  },
  message: {
    marginEnd: 16,
    marginStart: 16,
    marginTop: 16,
    fontSize: 16,
    textAlign: 'center',
    color: colors.BLACK_SECONDARY
  },
  buttonContainer: {
    height: 52,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 26
  }
}));

Error.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  buttonText: PropTypes.string,
  onButtonPress: PropTypes.func
};

Error.defaultProps = {
  title: 'Sorry.',
  message: 'Something went wrong.',
  buttonText: 'Go back',
  onButtonClick: () => null
};

export default Error;